export default __webpack_public_path__ + "static/media/Dataframe.026f84ce.jfif";